import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { Widget, ISort } from '@homeviews/models'

export const WIDGETS_FEATURE_KEY = 'widgets'

type WidgetsState = {
  widgets: Widget[]
  sort?: ISort
}

const initialWidgetsState: WidgetsState = {
  widgets: [],
  sort: null,
}

export const widgetsSlice = createSlice({
  name: WIDGETS_FEATURE_KEY,
  initialState: initialWidgetsState,
  reducers: {
    setWidgetsSort: (
      state,
      { payload: { sort } }: PayloadAction<{ sort: ISort }>,
    ) => {
      state.sort = sort
    },
  },
})

/*
 * Export reducer for store configuration.
 */
export const widgetsReducer = widgetsSlice.reducer

export const { setWidgetsSort } = widgetsSlice.actions

export const selectActiveWidgetsSort = (rootState: unknown) =>
  rootState[WIDGETS_FEATURE_KEY]?.sort

export const getWidgetsState = (rootState: unknown): WidgetsState =>
  rootState[WIDGETS_FEATURE_KEY]
